import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-41">
          <div className="col-span-1 md:col-span-2" data-id="element-42">
            <div className="flex items-center gap-3 mb-6" data-id="element-43">
              {/* Geometric logo mark */}
              <div className="flex items-center gap-0.5" data-id="element-44">
                <div className="w-1 h-6 bg-slate-700" data-id="element-45"></div>
                <div className="w-1 h-5 bg-slate-700" data-id="element-46"></div>
                <div className="w-1 h-7 bg-emerald-600" data-id="element-47"></div>
                <div className="w-1 h-5 bg-slate-700" data-id="element-48"></div>
              </div>
              <span className="font-bold text-white text-xl tracking-[0.15em]" data-id="element-49">
                KZEV
              </span>
            </div>
            <p className="max-w-xs text-sm leading-relaxed mb-6" data-id="element-50">
              Kompetenzzentrum für Exzellenz im Vertrieb. Wir transformieren
              B2B-Vertriebsorganisationen durch Technologie, Prozesse und
              Enablement.
            </p>
            <div className="text-sm" data-id="element-51">
              &copy; {new Date().getFullYear()} KZEV. Alle Rechte vorbehalten.
            </div>
          </div>

          <div data-id="element-52">
            <h4 className="text-white font-bold mb-4" data-id="element-53">Unternehmen</h4>
            <ul className="space-y-2 text-sm" data-id="element-54">
              <li data-id="element-55">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-56">
                  Über uns
                </a>
              </li>
              <li data-id="element-57">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-58">
                  Leistungen
                </a>
              </li>
              <li data-id="element-59">
                <a href="#process" className="hover:text-white transition-colors" data-id="element-60">
                  Vorgehensweise
                </a>
              </li>
              <li data-id="element-61">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-62">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-63">
            <h4 className="text-white font-bold mb-4" data-id="element-64">Rechtliches</h4>
            <ul className="space-y-2 text-sm" data-id="element-65">
              <li data-id="element-66">
                <a href="https://porthun.info/impressum/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-67">
                  Impressum
                </a>
              </li>
              <li data-id="element-68">
                <a href="https://porthun.info/datenschutz" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-69">
                  Datenschutz
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-white transition-colors" data-id="element-71">
                  AGB
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
}